import { WPCF7FormField } from '@/types'

const REQUIRED_ONE_OF_PREFIX = 'gf-required-one-of__'

export const parseRequiredOneOfGroup = (field: WPCF7FormField): string | null => {
  const classes = (field.cssClass || '').split(' ').filter(Boolean)
  const groupClass = classes.find((cls) => cls.startsWith(REQUIRED_ONE_OF_PREFIX))

  return groupClass ? groupClass.replace(REQUIRED_ONE_OF_PREFIX, '') : null
}

export const getRequiredOneOfFields = (
  fields: WPCF7FormField[],
  groupName: string,
  visibleFieldIds?: Set<string>
): WPCF7FormField[] => {
  return fields.filter((field) => {
    const fieldGroup = parseRequiredOneOfGroup(field)
    const isVisible = !visibleFieldIds || visibleFieldIds.has(field.id)

    return fieldGroup === groupName && isVisible
  })
}

export const hasMeaningfulValue = (value: unknown): boolean => {
  if (Array.isArray(value)) return value.length > 0
  return value !== undefined && value !== null && String(value).trim() !== ''
}
